$('#reload').on('click', function () {
  location.reload()
})
$(window).on('load', function () {
  $('#app-reloaded-time').text(moment().format('YYYY年MMMMDo H:mm:ss'))
})
